import { createWebHashHistory, createRouter } from 'vue-router';

import Home from '@src/pages/home/index.vue';
import Group from '@src/pages/group/index.vue';

const routes = [
  { path: '/', component: Home },
  {
    path: '/group',
    component: Group,
    redirect: '/group/list',
    children: [
      { path: 'list', component: () => import('@src/pages/group/list.vue') },
      {
        path: 'detail',
        component: () => import('@src/pages/group/detail.vue'),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
